var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 34.0418L13.4583 27.7085M16.625 27.7085L22.9583 34.0418M15.0417 27.7085V35.6252",
    stroke: "#0481AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 18.8021C3.1665 15.5366 3.1665 13.9039 4.78963 12.8894C6.41273 11.875 9.02511 11.875 14.2498 11.875H15.8332C21.0579 11.875 23.6702 11.875 25.2934 12.8894C26.9165 13.9039 26.9165 15.5366 26.9165 18.8021V20.7812C26.9165 24.0467 26.9165 25.6795 25.2934 26.6939C23.6702 27.7083 21.0579 27.7083 15.8332 27.7083H14.2498C9.02511 27.7083 6.41273 27.7083 4.78963 26.6939C3.1665 25.6795 3.1665 24.0467 3.1665 20.7812V18.8021Z",
    fill: "#0481AE",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 16.2283L27.1158 16.1088C30.4659 14.0985 32.1409 13.0934 33.487 13.5787C34.8332 14.064 34.8332 15.673 34.8332 18.891V20.6918C34.8332 23.9097 34.8332 25.5187 33.487 26.004C32.1409 26.4893 30.4659 25.4842 27.1158 23.474L26.9165 23.3543",
    fill: "#0481AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 16.2283L27.1158 16.1088C30.4659 14.0985 32.1409 13.0934 33.487 13.5787C34.8332 14.064 34.8332 15.673 34.8332 18.891V20.6918C34.8332 23.9097 34.8332 25.5187 33.487 26.004C32.1409 26.4893 30.4659 25.4842 27.1158 23.474L26.9165 23.3543",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7918 11.8752C21.978 11.8752 23.7502 10.103 23.7502 7.91683C23.7502 5.7307 21.978 3.9585 19.7918 3.9585C17.6057 3.9585 15.8335 5.7307 15.8335 7.91683C15.8335 10.103 17.6057 11.8752 19.7918 11.8752Z",
    fill: "#0481AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0835 11.875C13.7068 11.875 15.8335 9.74835 15.8335 7.125C15.8335 4.50165 13.7068 2.375 11.0835 2.375C8.46014 2.375 6.3335 4.50165 6.3335 7.125C6.3335 9.74835 8.46014 11.875 11.0835 11.875Z",
    fill: "#0481AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoot);
export default __webpack_public_path__ + "static/media/shoot.b902584328ac909d1c0626bb2593b407.svg";
export { ForwardRef as ReactComponent };